// extracted by mini-css-extract-plugin
export var blog_tags = "styles-module--blog_tags--bad84";
export var blog_tags_big = "styles-module--blog_tags_big--bbeb1";
export var blog_thumb_wrapper = "styles-module--blog_thumb_wrapper--2ab8c";
export var blog_title = "styles-module--blog_title--8b309";
export var blog_title_big = "styles-module--blog_title_big--c339b";
export var image = "styles-module--image--621e6";
export var product_update_wrapper = "styles-module--product_update_wrapper--cd6cb";
export var text_wrapper = "styles-module--text_wrapper--92a0f";
export var text_wrapper_big = "styles-module--text_wrapper_big--0941c";